import React from 'react'
import { connect } from 'react-redux'
import { FingerPrint } from 'loyal-react'
import PropTypes from 'prop-types'

const composeURL = ({ url, remoteSuffix = '', localSuffix = '' }) => {
  return url && `${url}/${url.indexOf('localhost') > -1 ? localSuffix : remoteSuffix}`
}

const FingerPrintContainer = ({ accessToken }) => {
  const endpoint = composeURL({
    url: process.env.REACT_APP_CLOUD_LOYALTY_ENDPOINT,
    remoteSuffix: 'cloudloyalty'
  })
  const subscriptionKey = process.env.REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    'Ocp-Apim-Subscription-Key': subscriptionKey
  }

  return (
    <span className='d-none'>
      <FingerPrint
        headers={headers}
        endpoint={endpoint}
      />
    </span>)
}

const mapStateToProps = ({
  oidc: {
    user: { access_token: accessToken }
  }
}) => ({
  accessToken
})

FingerPrintContainer.propTypes = {
  accessToken: PropTypes.string
}

export default connect(
  mapStateToProps,
  null
)(FingerPrintContainer)



// WEBPACK FOOTER //
// ./src/App/FingerPrint/FingerPrintContainer.js